// Auto-generated from locales/en.json — do not edit manually
// Run 'npm run i18n:generate' to regenerate

export const TranslationKey = {
  App: {
    Title: 'app.title',
  },
  NotFound: {
    Message: 'notFound.message',
    BackHome: 'notFound.backHome',
  },
  Common: {
    DeleteAriaLabel: 'common.deleteAriaLabel',
    UserMenuAriaLabel: 'common.userMenuAriaLabel',
    Loading: 'common.loading',
    AiGenerated: 'common.aiGenerated',
  },
  DateInput: {
    ChooseDate: 'dateInput.chooseDate',
    Placeholder: 'dateInput.placeholder',
    Months: 'dateInput.months',
    DayHeaders: 'dateInput.dayHeaders',
  },
  Home: {
    Agenda: {
      Retry: 'home.agenda.retry',
      DaysLate: 'home.agenda.daysLate',
      Sent: 'home.agenda.sent',
      InvoiceCount: 'home.agenda.invoiceCount', // base key — i18next selects the _<plural> form via count
      InvoiceCount_one: 'home.agenda.invoiceCount_one',
      InvoiceCount_other: 'home.agenda.invoiceCount_other',
      InvoiceCountHint: 'home.agenda.invoiceCountHint',
      MenuLabel: 'home.agenda.menuLabel',
      MenuIgnore: 'home.agenda.menuIgnore',
      TodayTitle: 'home.agenda.todayTitle',
      UpcomingTitle: 'home.agenda.upcomingTitle',
      UpcomingEmptyWeek: 'home.agenda.upcomingEmptyWeek',
      UpcomingSeeAll: 'home.agenda.upcomingSeeAll',
      IgnoredSummary: 'home.agenda.ignoredSummary', // base key — i18next selects the _<plural> form via count
      IgnoredSummary_one: 'home.agenda.ignoredSummary_one',
      IgnoredSummary_other: 'home.agenda.ignoredSummary_other',
      IgnoredSeeList: 'home.agenda.ignoredSeeList',
      DueDateHint: 'home.agenda.dueDateHint',
      DaysLateHint: 'home.agenda.daysLateHint',
      Expected: 'home.agenda.expected',
      ExpectedHint: 'home.agenda.expectedHint',
      SnoozedUntil: 'home.agenda.snoozedUntil',
      ExpectedOn: 'home.agenda.expectedOn',
    },
    EmptyARelancer: 'home.emptyARelancer',
    TransphereIndicator: {
      Message: 'home.transphereIndicator.message',
      MessageDesktop: 'home.transphereIndicator.messageDesktop',
    },
    TransphereUnsentIndicator: {
      Message: 'home.transphereUnsentIndicator.message', // base key — i18next selects the _<plural> form via count
      Message_one: 'home.transphereUnsentIndicator.message_one',
      Message_other: 'home.transphereUnsentIndicator.message_other',
      StepsModal: {
        Title: 'home.transphereUnsentIndicator.stepsModal.title',
        Intro: 'home.transphereUnsentIndicator.stepsModal.intro', // base key — i18next selects the _<plural> form via count
        Intro_one: 'home.transphereUnsentIndicator.stepsModal.intro_one',
        Intro_other: 'home.transphereUnsentIndicator.stepsModal.intro_other',
        Step1: 'home.transphereUnsentIndicator.stepsModal.step1',
        Step2: 'home.transphereUnsentIndicator.stepsModal.step2',
        Step3: 'home.transphereUnsentIndicator.stepsModal.step3',
        Close: 'home.transphereUnsentIndicator.stepsModal.close',
      },
    },
    TransphereBanner: {
      BrandName: 'home.transphereBanner.brandName',
      LearnMore: 'home.transphereBanner.learnMore',
      ActivationAction: 'home.transphereBanner.activationAction',
      SubscriptionAction: 'home.transphereBanner.subscriptionAction',
      SubscribedTitle: 'home.transphereBanner.subscribedTitle',
      SubscribedMessage: 'home.transphereBanner.subscribedMessage',
      NotSubscribedTitle: 'home.transphereBanner.notSubscribedTitle',
      NotSubscribedMessage: 'home.transphereBanner.notSubscribedMessage',
      SubscriptionInactiveTitle: 'home.transphereBanner.subscriptionInactiveTitle',
      SubscriptionInactiveMessage: 'home.transphereBanner.subscriptionInactiveMessage',
      ContactAction: 'home.transphereBanner.contactAction',
      ContactTitle: 'home.transphereBanner.contactTitle',
      ContactMessage: 'home.transphereBanner.contactMessage',
      ContactEncaissementTitle: 'home.transphereBanner.contactEncaissementTitle',
      ContactEncaissementMessage: 'home.transphereBanner.contactEncaissementMessage',
      ContactClose: 'home.transphereBanner.contactClose',
      InProgressProcessingTitle: 'home.transphereBanner.inProgressProcessingTitle',
      InProgressProcessingMessage: 'home.transphereBanner.inProgressProcessingMessage',
      InProgressPendingTitle: 'home.transphereBanner.inProgressPendingTitle',
      InProgressPendingMessage: 'home.transphereBanner.inProgressPendingMessage',
      InProgressIncompleteTitle: 'home.transphereBanner.inProgressIncompleteTitle',
      InProgressIncompleteMessage: 'home.transphereBanner.inProgressIncompleteMessage',
      InProgressRejectedTitle: 'home.transphereBanner.inProgressRejectedTitle',
      InProgressRejectedMessage: 'home.transphereBanner.inProgressRejectedMessage',
    },
    Tabs: {
      ARelancer: 'home.tabs.aRelancer',
      Encaissees: 'home.tabs.encaissees',
      BadgeAriaLabel: 'home.tabs.badgeAriaLabel',
    },
    Deactivated: {
      Empty: {
        Ignorees: 'home.deactivated.empty.ignorees',
        Encaissees: 'home.deactivated.empty.encaissees',
      },
      Row: {
        Reactivate: 'home.deactivated.row.reactivate',
      },
    },
    Paid: {
      Retry: 'home.paid.retry',
      LoadMore: 'home.paid.loadMore',
      CountHint: 'home.paid.countHint',
      Row: {
        BadgeFull: 'home.paid.row.badgeFull',
        BadgePartial: 'home.paid.row.badgePartial',
        PaidOn: 'home.paid.row.paidOn',
        RemainingBalance: 'home.paid.row.remainingBalance',
        Reactivate: 'home.paid.row.reactivate',
      },
    },
    Snooze: {
      Hours24: 'home.snooze.Hours24',
      Days7: 'home.snooze.Days7',
      Days14: 'home.snooze.Days14',
      Custom: 'home.snooze.Custom',
      Indefinite: 'home.snooze.Indefinite',
    },
    IgnoreModal: {
      Heading: 'home.ignoreModal.heading',
      SectionSnooze: 'home.ignoreModal.sectionSnooze',
      SectionIgnore: 'home.ignoreModal.sectionIgnore',
      IndefiniteLabel: 'home.ignoreModal.indefiniteLabel',
      NoteLabel: 'home.ignoreModal.noteLabel',
      NotePlaceholder: 'home.ignoreModal.notePlaceholder',
      CustomDateRequired: 'home.ignoreModal.customDateRequired',
      CustomDateNotInFuture: 'home.ignoreModal.customDateNotInFuture',
      Save: 'home.ignoreModal.save',
      Cancel: 'home.ignoreModal.cancel',
    },
    PaidAction: {
      Tooltip: 'home.paidAction.tooltip',
      UnreachableError: 'home.paidAction.unreachableError',
    },
    FollowUp: {
      Loading: 'home.followUp.loading',
      Error: 'home.followUp.error',
      RelanceSent: 'home.followUp.relanceSent',
      RelanceRank: 'home.followUp.relanceRank',
      RelanceRankPostponed: 'home.followUp.relanceRankPostponed',
      RelanceRankHint: 'home.followUp.relanceRankHint',
      InvoiceLine: 'home.followUp.invoiceLine',
    },
    ActionModal: {
      HeadingSnoozed: 'home.actionModal.headingSnoozed',
      HeadingIgnored: 'home.actionModal.headingIgnored',
      HeadingExpected: 'home.actionModal.headingExpected',
      BringForward: 'home.actionModal.bringForward',
      CollectBalance: 'home.actionModal.collectBalance',
      SnoozeOrIgnore: 'home.actionModal.snoozeOrIgnore',
      Close: 'home.actionModal.close',
    },
    ReactivateModal: {
      Heading: 'home.reactivateModal.heading',
      ReasonLabel: 'home.reactivateModal.reasonLabel',
      ReasonPlaceholder: 'home.reactivateModal.reasonPlaceholder',
      Reactivate: 'home.reactivateModal.reactivate',
      Cancel: 'home.reactivateModal.cancel',
    },
    Greeting: {
      Morning: 'home.greeting.morning',
      Afternoon: 'home.greeting.afternoon',
      Evening: 'home.greeting.evening',
      SummaryHeading: 'home.greeting.summaryHeading',
      RelanceCount: 'home.greeting.relanceCount', // base key — i18next selects the _<plural> form via count
      RelanceCount_zero: 'home.greeting.relanceCount_zero',
      RelanceCount_one: 'home.greeting.relanceCount_one',
      RelanceCount_other: 'home.greeting.relanceCount_other',
    },
    LastSync: {
      Label: 'home.lastSync.label',
      Filling: 'home.lastSync.filling',
      Refresh: 'home.lastSync.refresh',
      JustNow: 'home.lastSync.justNow',
      Minutes: 'home.lastSync.minutes',
      Hours: 'home.lastSync.hours',
      Yesterday: 'home.lastSync.yesterday',
      OnDate: 'home.lastSync.onDate',
      FullResync: {
        Title: 'home.lastSync.fullResync.title',
        Body: 'home.lastSync.fullResync.body',
        Confirm: 'home.lastSync.fullResync.confirm',
        Cancel: 'home.lastSync.fullResync.cancel',
        Cooldown: 'home.lastSync.fullResync.cooldown',
      },
    },
    SyncChecklist: {
      GreetingSubtitle: 'home.syncChecklist.greetingSubtitle',
      Items: {
        FoldersAnalyzed: 'home.syncChecklist.items.foldersAnalyzed',
        RelancePreparation: 'home.syncChecklist.items.relancePreparation',
        Finalizing: 'home.syncChecklist.items.finalizing',
      },
      ElapsedSeconds: 'home.syncChecklist.elapsedSeconds',
      ElapsedMinutes: 'home.syncChecklist.elapsedMinutes',
    },
    NoSectionAccess: {
      Title: 'home.noSectionAccess.title',
      Message: 'home.noSectionAccess.message',
    },
    SyncFailed: {
      Title: 'home.syncFailed.title',
      Body: 'home.syncFailed.body',
      Retry: 'home.syncFailed.retry',
    },
    Receivables: {
      Total: 'home.receivables.total',
      Overdue: 'home.receivables.overdue',
      Over90: 'home.receivables.over90',
    },
  },
  Header: {
    HomeName: 'header.homeName',
    History: 'header.history',
    Profile: 'header.profile',
    Settings: 'header.settings',
    ChangeCompany: 'header.changeCompany',
    ChangeCompanyError: 'header.changeCompanyError',
    ChangeCompanyLoading: 'header.changeCompanyLoading',
    Logout: 'header.logout',
    LogoutConfirmDialog: {
      Heading: 'header.logoutConfirmDialog.heading',
      Body: 'header.logoutConfirmDialog.body',
      Confirm: 'header.logoutConfirmDialog.confirm',
      Cancel: 'header.logoutConfirmDialog.cancel',
    },
  },
  CustomerFollowUp: {
    Title: 'customerFollowUp.title',
    StatementSent: 'customerFollowUp.statementSent',
    StatementSentDated: 'customerFollowUp.statementSentDated',
    FollowUps: {
      Toggle: 'customerFollowUp.followUps.toggle',
    },
    Toast: {
      Success: 'customerFollowUp.toast.success',
      Failure: 'customerFollowUp.toast.failure',
    },
    Tabs: {
      Email: 'customerFollowUp.tabs.email',
      SuiviClient: 'customerFollowUp.tabs.suiviClient',
      HistoryCountAriaLabel: 'customerFollowUp.tabs.historyCountAriaLabel',
    },
    Email: {
      Subject: 'customerFollowUp.email.subject',
      Recipient: 'customerFollowUp.email.recipient',
      Cc: 'customerFollowUp.email.cc',
      Bcc: 'customerFollowUp.email.bcc',
      Copies: 'customerFollowUp.email.copies',
      Tone: 'customerFollowUp.email.tone',
      AddFile: 'customerFollowUp.email.addFile',
      SignatureHint: 'customerFollowUp.email.signatureHint',
      PaymentLink: {
        Label: 'customerFollowUp.email.paymentLink.label',
        Label_one: 'customerFollowUp.email.paymentLink.label_one',
        Label_other: 'customerFollowUp.email.paymentLink.label_other',
      },
      Confirmation: 'customerFollowUp.email.confirmation',
      Send: 'customerFollowUp.email.send',
      SendAndNext: 'customerFollowUp.email.sendAndNext',
      Errors: {
        SubjectRequired: 'customerFollowUp.email.errors.subjectRequired',
        SubjectMaxLength: 'customerFollowUp.email.errors.subjectMaxLength',
        EmailAddressRequired: 'customerFollowUp.email.errors.emailAddressRequired',
        EmailAddressInvalid: 'customerFollowUp.email.errors.emailAddressInvalid',
        ContentRequired: 'customerFollowUp.email.errors.contentRequired',
        InvalidFormat: 'customerFollowUp.email.errors.invalidFormat',
        FileTooLarge: 'customerFollowUp.email.errors.fileTooLarge',
        DuplicateFile: 'customerFollowUp.email.errors.duplicateFile',
        TotalAttachmentsTooLarge: 'customerFollowUp.email.errors.totalAttachmentsTooLarge',
      },
      Tones: {
        Courteous: 'customerFollowUp.email.tones.courteous',
        Professional: 'customerFollowUp.email.tones.professional',
        Severe: 'customerFollowUp.email.tones.severe',
        Custom: 'customerFollowUp.email.tones.custom',
      },
      ToneDescriptions: {
        Courteous: 'customerFollowUp.email.toneDescriptions.courteous',
        Professional: 'customerFollowUp.email.toneDescriptions.professional',
        Severe: 'customerFollowUp.email.toneDescriptions.severe',
        Custom: 'customerFollowUp.email.toneDescriptions.custom',
      },
      Toast: {
        AiFallback: 'customerFollowUp.email.toast.aiFallback',
      },
      DeleteAutoAttachmentDialog: {
        Heading: 'customerFollowUp.email.deleteAutoAttachmentDialog.heading',
        Body: 'customerFollowUp.email.deleteAutoAttachmentDialog.body',
        Confirm: 'customerFollowUp.email.deleteAutoAttachmentDialog.confirm',
        Cancel: 'customerFollowUp.email.deleteAutoAttachmentDialog.cancel',
      },
      AttachmentFetchFailedDialog: {
        Heading: 'customerFollowUp.email.attachmentFetchFailedDialog.heading',
        Body: 'customerFollowUp.email.attachmentFetchFailedDialog.body',
        Confirm: 'customerFollowUp.email.attachmentFetchFailedDialog.confirm',
        Cancel: 'customerFollowUp.email.attachmentFetchFailedDialog.cancel',
      },
      NoAttachmentsDialog: {
        Heading: 'customerFollowUp.email.noAttachmentsDialog.heading',
        Body: 'customerFollowUp.email.noAttachmentsDialog.body',
        Confirm: 'customerFollowUp.email.noAttachmentsDialog.confirm',
        Cancel: 'customerFollowUp.email.noAttachmentsDialog.cancel',
      },
      CustomTemplate: {
        Create: 'customerFollowUp.email.customTemplate.create',
        Edit: 'customerFollowUp.email.customTemplate.edit',
        LanguageLabel: 'customerFollowUp.email.customTemplate.languageLabel',
        LoadError: 'customerFollowUp.email.customTemplate.loadError',
      },
    },
    NoLongerAvailable: 'customerFollowUp.noLongerAvailable',
    AlreadySent: 'customerFollowUp.alreadySent',
    Recap: {
      Heading: 'customerFollowUp.recap.heading',
      Error: 'customerFollowUp.recap.error',
      CollectBalance: 'customerFollowUp.recap.collectBalance',
      SnoozeOrIgnore: 'customerFollowUp.recap.snoozeOrIgnore',
      ReceivablesTotal: 'customerFollowUp.recap.receivablesTotal',
      TotalDue: 'customerFollowUp.recap.totalDue',
    },
    Pending: {
      Failed: 'customerFollowUp.pending.failed',
    },
    GenerationStatus: {
      Queued: 'customerFollowUp.generationStatus.queued',
      Generating: 'customerFollowUp.generationStatus.generating',
      PlanningEmail: 'customerFollowUp.generationStatus.planningEmail',
      GeneratingEmail: 'customerFollowUp.generationStatus.generatingEmail',
    },
    MissingInfo: {
      Title: 'customerFollowUp.missingInfo.title',
      TitleOptional: 'customerFollowUp.missingInfo.titleOptional',
      TitleTransactions: 'customerFollowUp.missingInfo.titleTransactions',
      TitleBothOptional: 'customerFollowUp.missingInfo.titleBothOptional',
      Intro: 'customerFollowUp.missingInfo.intro',
      Step1Prefix: 'customerFollowUp.missingInfo.step1Prefix',
      Step2ClientPrefix: 'customerFollowUp.missingInfo.step2ClientPrefix',
      Step2TransactionsPrefix: 'customerFollowUp.missingInfo.step2TransactionsPrefix',
      Step2TransactionsAlsoPrefix: 'customerFollowUp.missingInfo.step2TransactionsAlsoPrefix',
      Save: 'customerFollowUp.missingInfo.save',
      Step3: 'customerFollowUp.missingInfo.step3',
      Retry: 'customerFollowUp.missingInfo.retry',
      Email: 'customerFollowUp.missingInfo.email',
      Language: 'customerFollowUp.missingInfo.language',
      PaymentTerm: 'customerFollowUp.missingInfo.paymentTerm',
      OpenInvoice: 'customerFollowUp.missingInfo.openInvoice',
      OpenInvoiceUnnumbered: 'customerFollowUp.missingInfo.openInvoiceUnnumbered',
      OpenInscription: 'customerFollowUp.missingInfo.openInscription',
      OpenInscriptionNumbered: 'customerFollowUp.missingInfo.openInscriptionNumbered',
    },
    ManualIntervention: {
      Contact: 'customerFollowUp.manualIntervention.contact',
      Phone: 'customerFollowUp.manualIntervention.phone',
      Content: 'customerFollowUp.manualIntervention.content',
      NextFollowUp: 'customerFollowUp.manualIntervention.nextFollowUp',
      ChooseDate: 'customerFollowUp.manualIntervention.chooseDate',
      Save: 'customerFollowUp.manualIntervention.save',
      Saving: 'customerFollowUp.manualIntervention.saving',
      Errors: {
        ContactRequired: 'customerFollowUp.manualIntervention.errors.contactRequired',
        PhoneInvalid: 'customerFollowUp.manualIntervention.errors.phoneInvalid',
        ContentRequired: 'customerFollowUp.manualIntervention.errors.contentRequired',
        NextFollowUpRequired: 'customerFollowUp.manualIntervention.errors.nextFollowUpRequired',
      },
    },
  },
  Settings: {
    Title: 'settings.title',
    UserSection: 'settings.userSection',
    CompanySection: 'settings.companySection',
    Theme: 'settings.theme',
    ThemeDescription: 'settings.themeDescription',
    Language: 'settings.language',
    LanguageDescription: 'settings.languageDescription',
    PortalAutoOpen: 'settings.portalAutoOpen',
    PortalAutoOpenDescription: 'settings.portalAutoOpenDescription',
    PortalAutoOpenError: 'settings.portalAutoOpenError',
    ReplyToEmail: 'settings.replyToEmail',
    ReplyToEmailDescription: 'settings.replyToEmailDescription',
    ReplyToEmailSave: 'settings.replyToEmailSave',
    ReplyToEmailSaved: 'settings.replyToEmailSaved',
    ReplyToEmailError: 'settings.replyToEmailError',
    BccEmail: 'settings.bccEmail',
    BccEmailDescription: 'settings.bccEmailDescription',
    BccEmailSave: 'settings.bccEmailSave',
    BccEmailSaved: 'settings.bccEmailSaved',
    BccEmailError: 'settings.bccEmailError',
    RelanceMinimumAmount: 'settings.relanceMinimumAmount',
    RelanceMinimumAmountDescription: 'settings.relanceMinimumAmountDescription',
    RelanceMinimumAmountSave: 'settings.relanceMinimumAmountSave',
    RelanceMinimumAmountSaved: 'settings.relanceMinimumAmountSaved',
    RelanceMinimumAmountError: 'settings.relanceMinimumAmountError',
    RelanceMinimumAmountInvalid: 'settings.relanceMinimumAmountInvalid',
    RelanceFollowUpDays: 'settings.relanceFollowUpDays',
    RelanceFollowUpDaysDescription: 'settings.relanceFollowUpDaysDescription',
    RelanceFollowUpDaysUnit: 'settings.relanceFollowUpDaysUnit',
    RelanceFollowUpDaysSave: 'settings.relanceFollowUpDaysSave',
    RelanceFollowUpDaysSaved: 'settings.relanceFollowUpDaysSaved',
    RelanceFollowUpDaysError: 'settings.relanceFollowUpDaysError',
    RelanceFollowUpDaysInvalid: 'settings.relanceFollowUpDaysInvalid',
    DevSection: 'settings.devSection',
    NoAiMode: 'settings.noAiMode',
    NoAiModeDescription: 'settings.noAiModeDescription',
    SyncCompleted: 'settings.syncCompleted',
    SyncError: 'settings.syncError',
    SyncFailed: 'settings.syncFailed',
    SyncTimedOut: 'settings.syncTimedOut',
    SyncPhasePreprocessing: 'settings.syncPhasePreprocessing',
    SyncPhasePriorityRanking: 'settings.syncPhasePriorityRanking',
    SyncPhaseRelanceFill: 'settings.syncPhaseRelanceFill',
    SyncTitle: 'settings.syncTitle',
    SyncDescription: 'settings.syncDescription',
    SyncFull: 'settings.syncFull',
    SyncPartial: 'settings.syncPartial',
    SyncButtonIdle: 'settings.syncButtonIdle',
    SyncButtonRunning: 'settings.syncButtonRunning',
    CustomEmailTemplate: {
      Title: 'settings.customEmailTemplate.title',
      Description: 'settings.customEmailTemplate.description',
      Empty: 'settings.customEmailTemplate.empty',
      Create: 'settings.customEmailTemplate.create',
      Edit: 'settings.customEmailTemplate.edit',
      Delete: 'settings.customEmailTemplate.delete',
      LoadError: 'settings.customEmailTemplate.loadError',
      DeleteError: 'settings.customEmailTemplate.deleteError',
      DeleteDialog: {
        Heading: 'settings.customEmailTemplate.deleteDialog.heading',
        Body: 'settings.customEmailTemplate.deleteDialog.body',
        Confirm: 'settings.customEmailTemplate.deleteDialog.confirm',
        Cancel: 'settings.customEmailTemplate.deleteDialog.cancel',
      },
    },
  },
  TaskCategories: {
    CustomerRelance: 'taskCategories.customerRelance',
    MissingData: 'taskCategories.missingData',
    Other: 'taskCategories.other',
  },
  Auth: {
    SigninError: 'auth.signinError',
    NoCompanyAccess: 'auth.noCompanyAccess',
    Retry: 'auth.retry',
    PortalError: 'auth.portalError',
    ConnectSessionFailed: 'auth.connectSessionFailed',
    Reconnecting: 'auth.reconnecting',
    Loading: 'auth.loading',
    SigninInProgress: 'auth.signinInProgress',
  },
  TenantPicker: {
    Title: 'tenantPicker.title',
    Subtitle: 'tenantPicker.subtitle',
    ColCode: 'tenantPicker.colCode',
    ColCompany: 'tenantPicker.colCompany',
    ColUser: 'tenantPicker.colUser',
    ConnectUnavailable: 'tenantPicker.connectUnavailable',
    RecordCount: 'tenantPicker.recordCount', // base key — i18next selects the _<plural> form via count
    RecordCount_one: 'tenantPicker.recordCount_one',
    RecordCount_other: 'tenantPicker.recordCount_other',
  },
  FileViewer: {
    Close: 'fileViewer.close',
    UnsupportedType: 'fileViewer.unsupportedType',
  },
  ApiErrors: {
    Generic: 'apiErrors.generic',
    ManualAttachmentUnsupportedFormat: 'apiErrors.manualAttachmentUnsupportedFormat',
    ManualAttachmentTooLarge: 'apiErrors.manualAttachmentTooLarge',
    ManualAttachmentFormatMismatch: 'apiErrors.manualAttachmentFormatMismatch',
    MissingConnectToken: 'apiErrors.missingConnectToken',
    EventsPageInvalid: 'apiErrors.eventsPageInvalid',
    TenantInvalidIdentity: 'apiErrors.tenantInvalidIdentity',
    TenantUnauthorized: 'apiErrors.tenantUnauthorized',
    SyncAlreadyRunning: 'apiErrors.syncAlreadyRunning',
    StaleCopy: 'apiErrors.staleCopy',
    WholesaleEmptyPayload: 'apiErrors.wholesaleEmptyPayload',
    BridgeSyncInvalidPayload: 'apiErrors.bridgeSyncInvalidPayload',
    BridgeSyncRejected: 'apiErrors.bridgeSyncRejected',
    SyncStartDateTooOld: 'apiErrors.syncStartDateTooOld',
    SyncStartDateInvalid: 'apiErrors.syncStartDateInvalid',
  },
  RelanceDescription: {
    CreditLimit: 'relanceDescription.creditLimit',
  },
  InitialSync: {
    Title: 'initialSync.title',
    StartButton: 'initialSync.startButton',
    ErrorTitle: 'initialSync.errorTitle',
    RetryButton: 'initialSync.retryButton',
    ToastSuccess: 'initialSync.toastSuccess',
    BridgeUnreachableError: 'initialSync.bridgeUnreachableError',
    BridgeUnreachableRetry: 'initialSync.bridgeUnreachableRetry',
    BridgeNoSessionError: 'initialSync.bridgeNoSessionError',
    BridgeNoSessionRetry: 'initialSync.bridgeNoSessionRetry',
    BridgeOutdatedError: 'initialSync.bridgeOutdatedError',
    BridgeOutdatedRetry: 'initialSync.bridgeOutdatedRetry',
    RelanceNoAccessTitle: 'initialSync.relanceNoAccessTitle',
    RelanceNoAccessMessage: 'initialSync.relanceNoAccessMessage',
    RelanceNoAccessMessageConnect: 'initialSync.relanceNoAccessMessageConnect',
    RelanceNoAccessContinue: 'initialSync.relanceNoAccessContinue',
  },
  Onboarding: {
    Nav: {
      Back: 'onboarding.nav.back',
      Next: 'onboarding.nav.next',
      Continue: 'onboarding.nav.continue',
    },
    DraftTextFlag: 'onboarding.draftTextFlag',
    Welcome: {
      Title: 'onboarding.welcome.title',
      Hook: 'onboarding.welcome.hook',
      BodyOne: 'onboarding.welcome.bodyOne',
      BodyTwo: 'onboarding.welcome.bodyTwo',
      Note: 'onboarding.welcome.note',
    },
    ValueProps: {
      Title: 'onboarding.valueProps.title',
      Subtitle: 'onboarding.valueProps.subtitle',
      Items: {
        Summary: 'onboarding.valueProps.items.summary',
        UnpaidInvoices: 'onboarding.valueProps.items.unpaidInvoices',
        PersonalizedEmails: 'onboarding.valueProps.items.personalizedEmails',
        Attachments: 'onboarding.valueProps.items.attachments',
        PaymentLink: 'onboarding.valueProps.items.paymentLink',
        History: 'onboarding.valueProps.items.history',
      },
      PaymentLinkNotIncluded: 'onboarding.valueProps.paymentLinkNotIncluded',
      SuggestsBadge: 'onboarding.valueProps.suggestsBadge',
    },
    Consent: {
      Title: 'onboarding.consent.title',
      Subtitle: 'onboarding.consent.subtitle',
      LegalText: 'onboarding.consent.legalText',
      CheckboxLabel: 'onboarding.consent.checkboxLabel',
      RefuseLink: 'onboarding.consent.refuseLink',
    },
    RefuseConfirm: {
      Title: 'onboarding.refuseConfirm.title',
      Body: 'onboarding.refuseConfirm.body',
      Confirm: 'onboarding.refuseConfirm.confirm',
      Cancel: 'onboarding.refuseConfirm.cancel',
    },
    Refused: {
      Title: 'onboarding.refused.title',
      Message: 'onboarding.refused.message',
      Continue: 'onboarding.refused.continue',
    },
    Unavailable: {
      Title: 'onboarding.unavailable.title',
      Body: 'onboarding.unavailable.body',
      Contact: 'onboarding.unavailable.contact',
    },
    Reactivation: {
      Title: 'onboarding.reactivation.title',
      Description: 'onboarding.reactivation.description',
      ReactivateButton: 'onboarding.reactivation.reactivateButton',
      ModalHeading: 'onboarding.reactivation.modalHeading',
      ConfirmButton: 'onboarding.reactivation.confirmButton',
      CancelButton: 'onboarding.reactivation.cancelButton',
    },
  },
  SyncStartDate: {
    Title: 'syncStartDate.title',
    Description: 'syncStartDate.description',
    DefaultDescription: 'syncStartDate.defaultDescription',
    DateLabel: 'syncStartDate.dateLabel',
    SaveBtn: 'syncStartDate.saveBtn',
    Saving: 'syncStartDate.saving',
    SaveSuccess: 'syncStartDate.saveSuccess',
    ErrorTooOld: 'syncStartDate.errorTooOld',
    ErrorLoadFailed: 'syncStartDate.errorLoadFailed',
    ErrorSaveFailed: 'syncStartDate.errorSaveFailed',
    ResyncTitle: 'syncStartDate.resyncTitle',
    ResyncBody: 'syncStartDate.resyncBody',
    ResyncConfirm: 'syncStartDate.resyncConfirm',
    ResyncCancel: 'syncStartDate.resyncCancel',
    ResyncLater: 'syncStartDate.resyncLater',
  },
  UpcomingRelances: {
    Title: 'upcomingRelances.title',
    Empty: 'upcomingRelances.empty',
  },
  IgnoredRelances: {
    Title: 'ignoredRelances.title',
  },
  History: {
    Title: 'history.title',
    Empty: 'history.empty',
    EmptyClient: 'history.emptyClient',
    Error: 'history.error',
    LoadMoreError: 'history.loadMoreError',
    Retry: 'history.retry',
    Columns: {
      Date: 'history.columns.date',
      Type: 'history.columns.type',
      Detail: 'history.columns.detail',
      Description: 'history.columns.description',
      Total: 'history.columns.total',
    },
    AccessDenied: {
      Title: 'history.accessDenied.title',
      Message: 'history.accessDenied.message',
    },
    Types: {
      RELANCE_COMPLETED: 'history.types.RELANCE_COMPLETED',
      NOTE_ADDED: 'history.types.NOTE_ADDED',
      RELANCE_DEACTIVATED: 'history.types.RELANCE_DEACTIVATED',
      RELANCE_SNOOZED: 'history.types.RELANCE_SNOOZED',
      RELANCE_REACTIVATED: 'history.types.RELANCE_REACTIVATED',
      RELANCE_PAID_FULL: 'history.types.RELANCE_PAID_FULL',
      RELANCE_PAID_PARTIAL: 'history.types.RELANCE_PAID_PARTIAL',
      TRANSPHERE_PAYMENTS_APPLIED: 'history.types.TRANSPHERE_PAYMENTS_APPLIED',
    },
    PaymentsApplied: {
      Invoices: 'history.paymentsApplied.invoices', // base key — i18next selects the _<plural> form via count
      Invoices_one: 'history.paymentsApplied.invoices_one',
      Invoices_other: 'history.paymentsApplied.invoices_other',
      Customers: 'history.paymentsApplied.customers', // base key — i18next selects the _<plural> form via count
      Customers_one: 'history.paymentsApplied.customers_one',
      Customers_other: 'history.paymentsApplied.customers_other',
    },
    Detail: {
      InvoiceNumber: 'history.detail.invoiceNumber',
      NoteContent: 'history.detail.noteContent',
      PerformedBy: 'history.detail.performedBy',
      UnknownUser: 'history.detail.unknownUser',
      SystemActor: 'history.detail.systemActor',
      RecipientAddress: 'history.detail.recipientAddress',
      CcAddress: 'history.detail.ccAddress',
      BccAddress: 'history.detail.bccAddress',
      ReplyToAddress: 'history.detail.replyToAddress',
      Subject: 'history.detail.subject',
      AttachmentCount: 'history.detail.attachmentCount',
      SnoozeUntil: 'history.detail.snoozeUntil',
      Note: 'history.detail.note',
      Reason: 'history.detail.reason',
      None: 'history.detail.none',
      Reactivate: 'history.detail.reactivate',
      AutoReasonSnoozeExpired: 'history.detail.autoReasonSnoozeExpired',
      AutoReasonDebtIncreased: 'history.detail.autoReasonDebtIncreased',
      AutoReasonDebtChanged: 'history.detail.autoReasonDebtChanged',
      AmountReceived: 'history.detail.amountReceived',
      RemainingBalance: 'history.detail.remainingBalance',
      CustomersUpdated: 'history.detail.customersUpdated',
      InvoicesApplied: 'history.detail.invoicesApplied',
    },
  },
  DevRanking: {
    Title: 'devRanking.title',
    Calculate: 'devRanking.calculate',
    Calculating: 'devRanking.calculating',
    Empty: 'devRanking.empty',
    Error: 'devRanking.error',
    Rank: 'devRanking.rank',
    RawScore: 'devRanking.rawScore',
    NormalizedScore: 'devRanking.normalizedScore',
    Reset: 'devRanking.reset',
    AmountScalingStat: 'devRanking.amountScalingStat',
    DaysOverdueScalingStat: 'devRanking.daysOverdueScalingStat',
    Breakdown: {
      Title: 'devRanking.breakdown.title',
      Delay: 'devRanking.breakdown.delay',
      Amount: 'devRanking.breakdown.amount',
      Complexity: 'devRanking.breakdown.complexity',
      Credit: 'devRanking.breakdown.credit',
      History: 'devRanking.breakdown.history',
      Total: 'devRanking.breakdown.total',
    },
  },
  DesktopSession: {
    Loading: 'desktopSession.loading',
    StaleBanner: {
      Message: 'desktopSession.staleBanner.message',
      PromoteAction: 'desktopSession.staleBanner.promoteAction',
    },
  },
  AcombaBridge: {
    IconAriaLabel: 'acombaBridge.iconAriaLabel',
    PageName: 'acombaBridge.pageName',
    PanelTitle: 'acombaBridge.panelTitle',
    Gate: {
      Connecting: 'acombaBridge.gate.connecting',
    },
    Status: {
      Checking: 'acombaBridge.status.checking',
      NoBridge: 'acombaBridge.status.noBridge',
      NotConnected: 'acombaBridge.status.notConnected',
      Connected: 'acombaBridge.status.connected',
      SdkUnavailable: 'acombaBridge.status.sdkUnavailable',
      SdkUnavailableDetail: 'acombaBridge.status.sdkUnavailableDetail',
      SdkVersionMismatch: 'acombaBridge.status.sdkVersionMismatch',
      SdkVersionMismatchDetail: 'acombaBridge.status.sdkVersionMismatchDetail',
      SdkVersionMismatchVersionSuffix: 'acombaBridge.status.sdkVersionMismatchVersionSuffix',
      ReconnectFromAcomba: 'acombaBridge.status.reconnectFromAcomba',
    },
    Wizard: {
      Step1: 'acombaBridge.wizard.step1',
      CheckBtn: 'acombaBridge.wizard.checkBtn',
      RetryBtn: 'acombaBridge.wizard.retryBtn',
      Checking: 'acombaBridge.wizard.checking',
    },
    Cause: {
      AbsentTitle: 'acombaBridge.cause.absentTitle',
      AbsentBody: 'acombaBridge.cause.absentBody',
      StoppedTitle: 'acombaBridge.cause.stoppedTitle',
      StoppedBody: 'acombaBridge.cause.stoppedBody',
      StaleTitle: 'acombaBridge.cause.staleTitle',
      StaleBody: 'acombaBridge.cause.staleBody',
      UnhealthyTitle: 'acombaBridge.cause.unhealthyTitle',
      UnhealthyBody: 'acombaBridge.cause.unhealthyBody',
      UnreachableTitle: 'acombaBridge.cause.unreachableTitle',
      UnreachableBody: 'acombaBridge.cause.unreachableBody',
      CopyDiagnostics: 'acombaBridge.cause.copyDiagnostics',
      CopyDiagnosticsDone: 'acombaBridge.cause.copyDiagnosticsDone',
      CopyDiagnosticsFailed: 'acombaBridge.cause.copyDiagnosticsFailed',
    },
    Credentials: {
      SessionExpiredMsg: 'acombaBridge.credentials.sessionExpiredMsg',
    },
    Connected: {
      BridgeStatusLabel: 'acombaBridge.connected.bridgeStatusLabel',
      SdkStatusLabel: 'acombaBridge.connected.sdkStatusLabel',
      StatusHealthy: 'acombaBridge.connected.statusHealthy',
      CompanyLabel: 'acombaBridge.connected.companyLabel',
      UserLabel: 'acombaBridge.connected.userLabel',
    },
    Extraction: {
      Heading: 'acombaBridge.extraction.heading',
      Customers: 'acombaBridge.extraction.customers',
      Invoices: 'acombaBridge.extraction.invoices',
      Payments: 'acombaBridge.extraction.payments',
      Fetching: 'acombaBridge.extraction.fetching',
      Done: 'acombaBridge.extraction.done',
      Failed: 'acombaBridge.extraction.failed',
      Cancelled: 'acombaBridge.extraction.cancelled',
      Idle: 'acombaBridge.extraction.idle',
      RetryEntity: 'acombaBridge.extraction.retryEntity',
      RetrySync: 'acombaBridge.extraction.retrySync',
    },
    Errors: {
      InsufficientRights: 'acombaBridge.errors.insufficientRights',
      BridgeOutdated: 'acombaBridge.errors.bridgeOutdated',
      SyncIncomplete: 'acombaBridge.errors.syncIncomplete',
      StaleCopySync: 'acombaBridge.errors.staleCopySync',
      RelanceAccessDenied: 'acombaBridge.errors.relanceAccessDenied',
    },
    SessionReason: {
      AuthenticationFailed: 'acombaBridge.sessionReason.authenticationFailed',
      CompanyLocked: 'acombaBridge.sessionReason.companyLocked',
      NotOurLaunch: 'acombaBridge.sessionReason.notOurLaunch',
      Unknown: 'acombaBridge.sessionReason.unknown',
    },
    CompanyMatch: {
      MismatchWarning: 'acombaBridge.companyMatch.mismatchWarning',
      UnverifiableNote: 'acombaBridge.companyMatch.unverifiableNote',
    },
    BridgeOutdated: {
      BannerMessage: 'acombaBridge.bridgeOutdated.bannerMessage',
    },
  },
  CustomEmailTemplate: {
    Markers: {
      ContactName: 'customEmailTemplate.markers.contactName',
      Today: 'customEmailTemplate.markers.today',
      TotalDue: 'customEmailTemplate.markers.totalDue',
      TransactionsTable: 'customEmailTemplate.markers.transactionsTable',
    },
    Languages: {
      Fr: 'customEmailTemplate.languages.fr',
      En: 'customEmailTemplate.languages.en',
    },
    Modal: {
      Heading: 'customEmailTemplate.modal.heading',
      CompanyWide: 'customEmailTemplate.modal.companyWide',
      LanguageHint: 'customEmailTemplate.modal.languageHint',
      Subject: 'customEmailTemplate.modal.subject',
      Body: 'customEmailTemplate.modal.body',
      Insert: 'customEmailTemplate.modal.insert',
      InsertAriaLabel: 'customEmailTemplate.modal.insertAriaLabel',
      Save: 'customEmailTemplate.modal.save',
      Cancel: 'customEmailTemplate.modal.cancel',
      Errors: {
        AtLeastOneLanguage: 'customEmailTemplate.modal.errors.atLeastOneLanguage',
        SubjectRequired: 'customEmailTemplate.modal.errors.subjectRequired',
        BodyRequired: 'customEmailTemplate.modal.errors.bodyRequired',
        SubjectTooLong: 'customEmailTemplate.modal.errors.subjectTooLong',
        BodyTooLong: 'customEmailTemplate.modal.errors.bodyTooLong',
        Invalid: 'customEmailTemplate.modal.errors.invalid',
        SaveFailed: 'customEmailTemplate.modal.errors.saveFailed',
      },
    },
  },
} as const;
